import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "./Privacy.css";

const Privacy = () => {
    return (
        <div>
            <Header />
            <div className="privacy-container">
                <h1>Privacy Policy</h1>

                <p>Last updated: February 22, 2025</p>

                <h2>1. Introduction</h2>
                <p>
                    Welcome to The Brik (“Company”, “we”, “our”, “us”). This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit the-brik.com, the official website for The Brik products and services. We value your trust and are committed to protecting your privacy as you explore and purchase our unique products.
                </p>

                <h2>2. Information We Collect</h2>
                <p>
                    To provide you with a seamless shopping experience and to continually improve our offerings, we collect information about you in various ways. This may include:
                </p>
                <ul>
                    <li>
                        <b>Personal Data</b>: Information such as your name, email address, mailing address, and phone number that you provide when placing an order or signing up for updates.
                    </li>
                    <li>
                        <b>Usage Data</b>: Information automatically collected by our servers, including your IP address, browser type, operating system, and pages visited on our site. This helps us understand how you interact with The Brik website.
                    </li>
                    <li>
                        <b>Order Information</b>: Details related to your purchases, such as payment information, shipping address, and order history, which allow us to process and deliver your orders efficiently.
                    </li>
                </ul>

                <h2>3. How We Use Your Information</h2>
                <p>
                    We use the collected data for several purposes, including:
                </p>
                <ul>
                    <li>Processing and fulfilling your orders for The Brik products</li>
                    <li>Communicating with you about your orders, new products, and promotions</li>
                    <li>Enhancing and personalizing your experience on our website</li>
                    <li>Sending you marketing and promotional communications, if you opt in</li>
                    <li>Conducting data analysis to improve our products and services</li>
                </ul>

                <h2>4. Disclosure of Your Information</h2>
                <p>
                    We may share your information with trusted third parties under the following circumstances:
                </p>
                <ul>
                    <li>
                        <b>By Law or to Protect Rights</b>: When required by law or necessary to protect the rights, property, or safety of our customers or the public.
                    </li>
                    <li>
                        <b>Third-Party Service Providers</b>: With companies that assist us in operating our website, processing payments, shipping orders, or performing other business functions.
                    </li>
                    <li>
                        <b>Marketing Communications</b>: With your consent, or with an opportunity for you to withdraw consent, for marketing purposes.
                    </li>
                </ul>

                <h2>5. Cookies and Other Tracking Technologies</h2>
                <p>
                    We use cookies, web beacons, tracking pixels, and other tracking technologies to collect information about your activity on our site. These tools help us deliver a personalized experience and better understand how you interact with The Brik website. You can choose to disable cookies through your browser settings, although this may affect the functionality of the site.
                </p>

                <h2>6. Security of Your Information</h2>
                <p>
                    We implement a variety of administrative, technical, and physical security measures to safeguard your personal information. While we strive to protect your data, no security system is completely impenetrable, and we cannot guarantee the absolute security of your information.
                </p>

                <h2>7. Policy for Children</h2>
                <p>
                    Our site is not intended for children under the age of 13. We do not knowingly collect or solicit personal information from anyone under 13. If you believe we have inadvertently collected information from a child under 13, please contact us immediately.
                </p>

                <h2>8. Changes to This Privacy Policy</h2>
                <p>
                    We may update this Privacy Policy from time to time to reflect changes in our practices or for other operational, legal, or regulatory reasons. When changes are made, the “Last updated” date will be revised accordingly. We encourage you to review this policy periodically to stay informed about how we are protecting your information.
                </p>

                <h2>9. Contact Us</h2>
                <p>
                    If you have any questions or comments regarding this Privacy Policy or our data practices related to The Brik products and services, please contact us at:
                </p>
                <address>
                    <strong>The Brik LLC</strong>
                    <br />
                    119 Stanton Avenue
                    <br />
                    Ames, IA 50014
                    <br />
                    <a href="mailto:asray@the-brik.com">asray@the-brik.com</a>
                </address>
            </div>
            <Footer />
        </div>
    );
};

export default Privacy;
